import {
  type FeatureFlagsGetFeatureFlagsResponse,
  FeatureFlagsService,
} from "@common/client"
import { useQuery } from "@tanstack/react-query"
import { makeNoArgsQuery } from "./utils"

export const featureFlagsKey = ["featureFlags"] as const

export const featureFlagsQuery = makeNoArgsQuery({
  serviceCall: FeatureFlagsService.getFeatureFlags,
  queryKey: featureFlagsKey,
  staleTime: 5 * 60_000,
})

export function isFeatureEnabled(
  flags: FeatureFlagsGetFeatureFlagsResponse,
  flag: string,
): boolean {
  const value = flags[flag]
  return value !== undefined && value !== false
}

export function useFeatureFlag(flag: string): boolean | undefined {
  const { data } = useQuery(featureFlagsQuery())
  return data && isFeatureEnabled(data, flag)
}
